/* ══════════════════════════════════════════════════════════════
   DWL HEADER — alleen nog de zoek-placeholder.

   De sticky-header wordt volledig in CSS geregeld (zie dwl-header.css).
   Eerdere versies van dit bestand pinden de header met JS omdat
   position: sticky niet leek te werken; de echte oorzaak was
   overflow-x: hidden op html en body. Met overflow-x: clip werkt sticky
   gewoon en is er geen JS voor nodig.
   ══════════════════════════════════════════════════════════════ */
(function () {
  var PLACEHOLDER = 'Search ducks...';

  /* De nette route loopt via general.search.placeholder in
     locales/en.default.json. Dit pakt beide zoekbalken (header + drawer)
     in één keer; zetten we 'm later in de locale, dan kan dit eruit. */
  function setPlaceholder() {
    var fields = document.querySelectorAll('input[type="search"][name="q"]');
    for (var i = 0; i < fields.length; i++) {
      if (fields[i].placeholder !== PLACEHOLDER) {
        fields[i].placeholder = PLACEHOLDER;
      }
    }
  }

  function bind() {
    setPlaceholder();
    window.addEventListener('load', setPlaceholder);
    document.addEventListener('shopify:section:load', setPlaceholder);

    /* Vangnet voor laat ingeladen velden (predictive search vervangt het
       zoekveld soms na het inladen). */
    var tries = 0;
    var iv = setInterval(function () {
      tries++;
      setPlaceholder();
      if (tries > 20) clearInterval(iv);
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();
